import { differenceInWeeks } from 'date-fns'
import { orderBy } from 'lodash'
import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import { splitAdmissionsPeriod } from '../../conduct/generators'
import {
  createAdmissionsSlotsFrom,
  preventAdmissionsOutOfTimelineRange,
  removeHealthProceduresOfAdmissions
} from '../../mappers'
import { ITimelineMaternalInfant } from '~/interfaces'
import {
  getPregnancyTrimester,
  byTypeExceptAdmission,
  byTypeEqualToAdmission,
  filterHealthProceduresPer,
  timelineFilters
} from '~/utils'

export const mapperTimelineViewByTrimesterFrom = (
  healthProcedures: ITimelineMaternalInfant.IHealthProcedures[],
  startTrimesterDate: Date,
  endTrimesterDate: Date
): ITimelineMaternalInfant.ITrimesterTimelineData => {
  const timelineRange = [startTrimesterDate, endTrimesterDate]
  const healthProceduresWithoutAdmissions = filterHealthProceduresPer(healthProcedures, byTypeExceptAdmission)
  const healthProceduresInRange = timelineFilters(healthProceduresWithoutAdmissions).perEventStartDate(
    timelineRange
  ).value

  const admissions = filterHealthProceduresPer(healthProcedures, byTypeEqualToAdmission)
  const admissionSlots = createAdmissionsSlotsFrom(admissions, healthProceduresInRange)

  const admissionsInRange = preventAdmissionsOutOfTimelineRange(admissionSlots, timelineRange)

  const splitAdmissionsSlotsPerWeek = splitAdmissionsPeriod(admissionsInRange, 'weekly')

  const independentHealthProcedures = removeHealthProceduresOfAdmissions(healthProceduresInRange, admissions)
  const orderSlots: ITimelineMaternalInfant.IHealthProcedures[] = orderBy(
    [...splitAdmissionsSlotsPerWeek, ...independentHealthProcedures],
    ['startDate'],
    ['asc']
  )

  const groupedByWeek = groupBy(orderSlots, healthProcedure => {
    return differenceInWeeks(new Date(healthProcedure.endDate), startTrimesterDate)
  })

  const weeksStructured = mapValues(groupedByWeek, (healthProceduresGroupedByWeek, weekNumber) => {
    const compensatedWeek = parseInt(weekNumber) + 1

    return {
      id: compensatedWeek.toString(),
      rowSlots: healthProceduresGroupedByWeek
    }
  })

  const weeksGroupedByTrimester = groupBy(weeksStructured, weeksRegister => {
    return getPregnancyTrimester(+weeksRegister.id)
  })

  const trimesterStructured = mapValues(weeksGroupedByTrimester, (trimesterRegister, key: string) => {
    const totalHealthProcedures = trimesterRegister.reduce((acc, week) => acc + week.rowSlots.length, 0)

    return {
      id: key,
      totalSlots: totalHealthProcedures,
      weeks: trimesterRegister.reverse()
    }
  }) as ITimelineMaternalInfant.ITrimesterRowSlotsWrapper

  return {
    timelineId: new Date(healthProcedures[0].startDate).getTime(),
    trimester: Object.values(trimesterStructured).reverse()
  }
}
